module.exports = __webpack_public_path__ + "img/badge_color_pop-foundation.3aafeffb.svg";